import Vue from 'vue'

var cache = {
  _types: {},
  _roles: {},
  clear (name) {
    if (name) {
      this['_' + name] = {}
    } else {
      Object.keys(this).forEach((n, k) => {
        if (k[0] === '_') {
          this[k] = {}
        }
      })
    }
  },
  getExerciseType (id) {
    if (!this._types[id]) {
      this._types[id] = new Promise((resolve, reject) => {
        Vue.http.get(Vue.urls.exercise_type_view, {
          params: { id: id }
        }).then(res => {
          resolve(res.data)
        }).catch(res => {
          reject(res)
        })
      })
    }
    return this._types[id]
  },
  getKewenRole (id) {
    if (!this._roles[id]) {
      this._roles[id] = new Promise((resolve, reject) => {
        Vue.http.get(Vue.urls.lesson_role_view, {
          params: { id: id }
        }).then(res => {
          resolve(res.data)
        }).catch(res => {
          reject(res)
        })
      })
    }
    return this._roles[id]
  }
}

export default cache
